import { render } from "./ow-appointment-cancellation-types.vue?vue&type=template&id=6c2f300c"
import script from "./ow-appointment-cancellation-types.vue?vue&type=script&lang=js"
export * from "./ow-appointment-cancellation-types.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__